import * as commonScripts from '../common'

const cmpBackToTop = {
  component: null,

  init: function (element) {
    const _ = this;
    _.component = element;
	_.heroHeight = 0;
	_.fallbackHeroHeight = "600";
	_.getHeroHeight();
    _.onScrollEvent();
	_.onResizeEvent(element);
	_.onClickEvent(element);
  },

  getHeroHeight: function() {
    const heroContainer =  document.querySelector('.cmp-hero');
    const heroCarouselContainer =  document.querySelector('.cmp-hero-carousel');
	const _ = this;

	if(heroContainer)  {
		_.heroHeight = heroContainer.offsetHeight;
	
	} else if(heroCarouselContainer) {
		_.heroHeight = heroCarouselContainer.offsetHeight;

	} else {
		_.heroHeight = _.fallbackHeroHeight;
	}
  },

  onScrollEvent: function () {
    const _ = this
    window.addEventListener('scroll', () => {
      'use strict'
      if (
        document.body.scrollTop >= _.heroHeight ||
                document.documentElement.scrollTop >= _.heroHeight
      ) {
         _.component.classList.add('visible');
	  } else {
		_.component.classList.remove('visible');
      }
    });
  },

  onClickEvent: function(element) {
	const _ = this;
	element.querySelector('a').addEventListener('click', _.scrollToTop)
  },

  onResizeEvent: function(element)
  {
	const _ = this;
	const iconLink = element.querySelector('a')
	window.addEventListener('resize', function()
	{
		iconLink.removeEventListener('click', _.scrollToTop );
		_.getHeroHeight();
		iconLink.addEventListener('click', _.scrollToTop );
	}, false);
  },

  scrollToTop: function()
  {
	window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
export default cmpBackToTop
